export const iconFontAwesomeFoodBeverageHotdog = (
	<i className="fa-solid fa-hotdog"></i>
);
